export const environment = {
  production: true,
  productLogoLarge: 'assets/images/smart-menu-logo.svg',
  serverUrl: 'https://dev2.optimusai.ai/',
};
